import React from "react";
import { Mail } from "lucide-react";
import RealEstateAgencyNotice from "./RealEstateAgencyNotice";

const Footer = () => {
  return (
    <footer className="bg-primary text-white text-center">
      {/* 画像セクション */}
      <div className="bg-white py-4 flex justify-center items-center space-x-4">

        <div className="hidden sm:flex text-black text-left  pl-6">
          <p>
            不動産に関することなら<br />
          何でもご相談ください。<br />
          営業時間：9:00~18:00<br />
          ※土日祝を除きます
          </p>
        </div>

        <div className="sm:flex sm:pl-6 text-black text-left items-center text-xl">
          <p>アプロ山梨株式会社<br />
          ☎0555（25）6102</p>
        </div>
        
        <div className="hidden sm:flex pl-6">
          <a href="/contact">
            <button className="flex items-center px-6 py-3 bg-primary text-white font-bold text-lg rounded-lg transition-transform transform hover:scale-105">
              <Mail className="w-6 h-6 mr-2" />
              お問合せ
            </button>
          </a>
        </div>
      </div>

      {/* 免許業者（グループ会社）対応案内 */}
      <div className="border-t border-white/20 px-4 py-3 text-xs leading-relaxed">
        <RealEstateAgencyNotice className="max-w-3xl mx-auto" />
      </div>

      {/* 既存のフッター部分 */}
      <div className="p-4">
        <p>&copy; 2026 アプロ山梨株式会社. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
